export const extractId = (shopifyId: string): string => {
  if (!shopifyId) return "";
  return shopifyId.split("?")[0].split("/").slice(-1).pop() ?? "";
};
("");

export const sleep = (ms: number) => {
  return new Promise((r) => {
    setTimeout(r, ms);
  });
};

export const createRandomString = (length: number) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+=-_!@#$%^&*~";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
};
